import { render, staticRenderFns } from "./SessionDetect.vue?vue&type=template&id=53317c72&"
import script from "./SessionDetect.vue?vue&type=script&lang=js&"
export * from "./SessionDetect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports